// extracted by mini-css-extract-plugin
module.exports = {"permissions":"SecurityRolesGrid_permissions__2g0FZ"};